import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import {
	useGetQueryMemberStatusListQuery,
	useGetStaffAllListQuery,
} from '@/api/common';
import { useSelector } from 'react-redux';
import { selectMyInfo } from '@/pages/auth/authSlice';
import { TypeOfQueryMemberStatusListEnum } from '@/api/enum/common.enum';

export default function CentreProgramSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<any>();
	const userInfo = useSelector(selectMyInfo);
	const { data: staffList }: any = useGetStaffAllListQuery(
		userInfo?.currentBranch?.id || '',
		{
			refetchOnMountOrArgChange: true,
			skip: !userInfo?.currentBranch,
		}
	);

	const { data: queryMemberStatusList }: any = useGetQueryMemberStatusListQuery(
		TypeOfQueryMemberStatusListEnum.ADMITTED,
		{
			refetchOnMountOrArgChange: true,
		}
	);

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='statusList'
					label={t('member.status')}
					options={(queryMemberStatusList?.data || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='responsibleProgramWorkerList'
					label={t('member.responsibleProgramWorker')}
					options={staffList?.data || []}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='responsibleProfessionalStaffList'
					label={t('member.responsibleProfessionalStaff')}
					options={staffList?.data || []}
				/>
			</Grid>
		</Grid>
	);
}
